export const environment = {
    production: true,
    apiUrl: 'https://api.truefaith.life/api/admin/',
};
